export default {
  impacts: 'Impacts',
  dependencies: 'Dependencies',
  noEventsFilter: 'Idle entities',
  impactChain: 'Impact chain',
  resolvedAlarms: 'Resolved alarms',
  activeAlarm: 'Active alarm',
  impactDepends: 'Impact/Depends',
  treeOfDependencies: 'Tree of dependencies',
  charts: 'Charts',
  infosSearchLabel: 'Search infos',
  eventStatisticsMessage: '{ok} OK events\n{ko} KO Events',
  eventStatistics: 'Event statistics',
  addSelection: 'Add selection',
  actions: {
    titles: {
      editEntity: 'Edit entity',
      duplicateEntity: 'Duplicate entity',
      deleteEntity: 'Delete entity',
      pbehavior: 'Periodical behavior',
      variablesHelp: 'List of available variables',
      massEnable: 'Enable entities',
      massDisable: 'Disable entities',
    },
  },
  fab: {
    common: 'Add a new entity',
    addService: 'Add a new service entity',
  },
  popups: {
    massDeleteWarning: 'The mass deletion cannot be applied for some of selected elements, so they won\'t be deleted.',
    exportFailed: 'Failed to export entities in CSV format',
  },
};
